import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';

const baseBFGReportUrl = import.meta.env.REACT_APP_BFG_REPORT_URL;

const ShoppingCartUrlCell: FC<GridCellProps> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style }) => {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      style={{ ...style, textAlign: 'left' }}
    >
      <a className="text-link" rel="noreferrer noopener" target="_blank" href={`${baseBFGReportUrl}/Cart?companyUserId=${dataItem.companyUserId}`}>
        {dataItem.username}
      </a>
    </td>
  );
};

export default ShoppingCartUrlCell;
